<template>
    <a
        class="plugin-home-common-arrow-link"
        v-bind:class="{
             [`_${theme}`]: true,
         }"
        v-bind:href="url"
        v-if="text && url"
    >
        <span>
            {{ text }}
        </span>
        <icon name="arrow-right" width="16" height="16"/>
    </a>
</template>

<script>
export default {
    name: 'plugin-home-common-arrow-link',
    props: {
        text: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        theme: {
            type: String,
            default: 'default',
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-common-arrow-link {
    display: flex;
    align-items: center;
    gap: 8px;
    text-transform: uppercase;
    text-decoration: none;
    color: @color-gray-darker;

    span {
        .typography-caption();

        padding-top: 4px;
        font-weight: bold;
    }
    &._primary {
        color: @color-primary;
    }
}
</style>
